<ng-container *ngIf="topusers?.length">
  <div class="bg-white rounded-10 custom-shadow overflow-hidden mb-4">
    <div class="side-table-view-heading p-3 bg-blue-gradient text-white">
      <h4>Top {{ sport }} Pro Bettors</h4>
    </div>
    <ng-container
      *ngFor="let user of topusers; index as i"
      (click)="_common.getOS(true)"
      data-bs-toggle="modal"
      data-bs-target="#appusemodal"
    >
      <div class="top-winner-list-item">
        <div class="row px-3 g-3 my-3">
          <div class="mt-0 col-auto sidebar-user-img">
            <a [routerLink]="['/', user | UserSlug, 'profile', 'statistics']">
              <img
                src="{{ user.user_avatar | baseUrl }}"
                alt="user"
                class="img-fluid shadow-sm"
              />
            </a>
          </div>
          <div class="mt-0 col">
            <div class="sidelist-user-name fw-bold">
              <a
                [routerLink]="['/', user | UserSlug, 'profile', 'statistics']"
                >{{ user.name }}</a
              >
            </div>
            <div class="sidebar-winning-amt text-f10 mb-1">
              {{ sport }} Winnings
            </div>
            <strong>{{ user["total_winnings"] | CustomCurrency }}</strong>
          </div>
          <div class="mt-0 col-auto sidebar-rank-number">
            Rank : <strong class="text-blue">#{{ user.rank }}</strong>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="top-winner-list-item">
      <div class="row px-3 g-3 my-3">
        <div class="col-12 mt-0 text-end">
          <a [routerLink]="['/',sport?.toLowerCase(),'top-bettors']" class="small text-decoration-none"
            >Load More</a
          >
        </div>
      </div>
    </div>
  </div>
</ng-container>
